import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAzPxcOgrmZsFtdbYsORCzIbMXFJwbi7bA",
  authDomain: "fyp-authentication-3eec1.firebaseapp.com",
  projectId: "fyp-authentication-3eec1",
  storageBucket: "fyp-authentication-3eec1.appspot.com",
  messagingSenderId: "1059470751701",
  appId: "1:1059470751701:web:4fc6a93f3a1c7e6c4eaf5c",
  measurementId: "G-L33YLX4J0Z"
};
const firebaseapp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseapp);
export default firebaseapp;